import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from '../Tabs/Tabs';
import BedroomBuilderErrors from "./BedroomBuilderErrors";
import BedroomBuilderWorkspace from "./BedroomBuilderWorkspace";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

class BedroomBuilder extends React.Component {

  constructor(props) {
    super(props);

    /* prepare checklist data */
    var ru_amenities
    this.props.ru_amenities && this.props.ru_amenities.length
      ? ru_amenities = this.props.ru_amenities.map(ru_amenity => ru_amenity.id)
      : ru_amenities = []

    var property = this.props.property || {}

    var image_group_ids
    this.props.image_group && this.props.image_group.images.length
      ? image_group_ids = this.props.image_group.images.map(image => image.id)
      : image_group_ids = []

    this.state = {
      /* ui state */
      active_tab: 'general',
      loading: false,
      // /* errors */
      errors: this.props.errors ? this.props.errors : {},

      // /* bedroom paths */
      bedroom_save_path: this.props.bedroom_save_path,
      bedroom_create_path: this.props.bedroom_create_path,
      bedroom_amenities_path: this.props.bedroom_amenities_path,
      bedroom_image_group_path: this.props.bedroom_image_group_path,

      /* fields */
      code: this.props.code ? this.props.code : '',
      name: this.props.name ? this.props.name : '',
      description: this.props.description ? this.props.description : '',
      room_size: this.props.room_size ? this.props.room_size : '',
      bed_type: this.props.bed_type ? this.props.bed_type : '',
      order: this.props.order || [],
      /* generate check lists */
      composition_room_amenities: this.props.composition_room_amenities && this.props.composition_room_amenities.length ? this.props.composition_room_amenities : [],
      all_composition_rooms: this.props.all_composition_rooms && this.props.all_composition_rooms.length ? this.props.all_composition_rooms : [],
      composition_room_id: this.props.composition_room ? this.props.composition_room.id : null,
      // all_bedroom_types: this.props.all_bedroom_types && this.props.all_bedroom_types.length ? this.props.all_bedroom_types : [],

      /* associations */
      ru_amenities: ru_amenities,
      bedroom_type_bedrooms: this.props.bedroom_type_bedrooms,
      property: property,
      image_group_ids: image_group_ids,
      image_group: this.props.image_group ? this.props.image_group : null,
      images_data_table_path: this.props.images_data_table_path || null,
      all_properties: this.props.all_properties || [],

      /* helpers */
      date_format: null,
      is_new: this.props.is_new,
    }

    this.setActiveTab = this.setActiveTab.bind(this)
    this.onFieldChange = this.onFieldChange.bind(this)
    this.onChangeAmenities = this.onChangeAmenities.bind(this)
    this.onChangeBedroomTypes = this.onChangeBedroomTypes.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onImageChange = this.onImageChange.bind(this)
    this.prepParams = this.prepParams.bind(this)
    this.onChangeOrder = this.onChangeOrder.bind(this)
    this.onChangeCompositionRoom = this.onChangeCompositionRoom.bind(this)
  }

  render() {
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: ['data-dismiss="modal"']
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: this.onSubmit,
      },
    ]
    return (
      <div className="Builder">
        <Tabs tabs={this.tabs()} displayErrorMessage={(BedroomBuilderErrors.general(this.state.errors).length) ? true : false} />
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          {/* <BedroomBuilderErrors
            {...this.state}
            setActiveTab={this.setActiveTab}/> */}
          <BedroomBuilderWorkspace
            {...this.state}
            onFieldChange={this.onFieldChange}
            onChangeAmenities={this.onChangeAmenities}
            // onChangeBedroomTypes={this.onChangeBedroomTypes}
            onImageChange={this.onImageChange}
            onChangeOrder={this.onChangeOrder}
            onChangeCompositionRoom={this.onChangeCompositionRoom}

          />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    )
  }

  tabs() {
    var tabs = []

    tabs.push({
      tabName: I18n.t('general'),
      targetName: 'general',
      classes: this.state.active_tab === 'general' ? 'active' : null,
      changeHandler: this.setActiveTab,
      tabErrorCount: BedroomBuilderErrors.general(this.state.errors).length
    })

    // tabs.push({
    //   tabName: I18n.t('bedroom_types'),
    //   targetName: 'bedroom_types',
    //   classes: this.state.active_tab === 'bedroom_types' ? 'active' : null,
    //   changeHandler: this.setActiveTab,
    // })
    //
    tabs.push({
      tabName: I18n.t('amenities'),
      targetName: 'amenities',
      classes: this.state.active_tab === 'amenities' ? 'active' : null,
      changeHandler: this.setActiveTab,
    })

    tabs.push({
      tabName: I18n.t('images'),
      targetName: 'images',
      classes: this.state.active_tab === 'images' ? 'active' : null,
      changeHandler: this.setActiveTab,
    })

    return tabs;
  };

  updateAmenities(composition_room_id){
    var self = this
    var params = this.prepParams()

    self.setState({
      loading: true
    })
    setTimeout(function () {
      $.ajax({
        type: 'POST',
        url: self.props.composition_room_amenities_path,
        data: {
          composition_room_id: composition_room_id,
        }
      }).done(function (data) {
        if( data && data.errors && Object.keys(data.errors).length){
          self.setState({
            errors: data.errors
          })
          self.setState({ loading: false })
        }else {
          self.setState({
            loading: false,
            composition_room_amenities: data,
            ru_amenities: []
          })
        }
      })
    }, 1000)

  }

  onSubmit(){
    var self = this
    var params = this.prepParams()
    self.setState({ loading: true })
    setTimeout(function () {
      $.ajax({
        type: 'POST',
        url: self.state.is_new
                ? self.state.bedroom_create_path
                : self.state.bedroom_save_path,
        data: params
      }).done(function (data) {
        if(Object.keys(data.errors).length){
          self.setState({
            errors: data.errors
          })
          self.setState({ loading: false })
        }
        else {
          self.setState({ loading: false })
          window.parent.$(window.parent).trigger("bedroomSavedSuccessfully")
          if (parent && parent.refresh_data) {
            if (self.props.is_new == true) {
              parent.refresh_data(I18n.t('bedroom_created_successfully'));
            } else {
              parent.refresh_data(I18n.t('bedroom_saved_successfully'));
            }
          }
          if (parent && parent.hide_modal) {
            parent.hide_modal()
          }
        }
      })
    }, 1000)
  }

  prepParams() {
    return {
      bedroom: {
        code: this.state.code,
        name: this.state.name,
        description: this.state.description,
        room_size: this.state.room_size,
        bed_type: this.state.bed_type,
        image_group_id: this.state.image_group ? this.state.image_group.id : null,
        composition_room_id: this.state.composition_room_id ? this.state.composition_room_id : null,
      },
      ru_amenities: this.state.ru_amenities,
      bedroom_type_bedrooms: this.state.bedroom_type_bedrooms,
      property: this.state.property,
      image_group_ids: this.state.image_group_ids,
    }
  }

  setActiveTab(tab) {
    this.setState({
      active_tab: tab
    });
  };

  onChangeOrder(idsInOrder) {
    this.setState({image_group_ids:idsInOrder});
  };

  onFieldChange(event, value){
    if (event && event.target) {
      this.setState({
        [event.target.id]: event.target.value
      });
    } else {
      this.state[event] = value;
      this.setState(this.state);
    };
  };

  onChangeCompositionRoom(event) {
    this.setState({composition_room_id: event.target.value})
    this.updateAmenities(event.target.value)
  }

  onChangeAmenities(ru_amenities) {
    this.setState({ru_amenities: ru_amenities});
  };

  onChangeBedroomTypes(bedroom_type_bedrooms) {
    this.setState({bedroom_type_bedrooms: bedroom_type_bedrooms});
  };

  onImageChange(image_group) {
    var image_group_ids = image_group.images.map(image => image.id)
    if(image_group) {
      this.setState({
        image_group_ids: image_group_ids,
        image_group: image_group
      })
    } else {
      this.setState({
        image_group_ids: null,
        image_group: null
      });
    };
  };
}

export default BedroomBuilder
